import React from 'react';
import classNames from 'classnames';
import Select from 'react-select';

//import css from './TabNavHorizontal.module.css';

const SelectAutocomplete = (props) => {
    const {label, 
           value, 
           onChange, 
           options, 
           placeholder, 
           disabled, 
           error,
           isLoading,
           css } = props;
    
    // Convertir opciones al formato de react-select
    const selectOptions = options.map(opt => ({
        value: opt.id,
        label: opt.nombre
    }));

  // Encontrar la opción seleccionada
  const selectedOption = selectOptions.find(opt => opt.value === value) || null;

  const handleChange = (selectedOption) => {
    onChange(selectedOption ? selectedOption.value : '');
  };

  // Estilos personalizados para react-select
  const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: 'white',
        borderColor: error ? '#ff0000' : (state.isFocused ? '#b8bfd1' : '#e7e7e7'),
        borderRadius: '8px',
        borderWidth: '1px',
        boxShadow: state.isFocused ? '0 0 0 1px #b8bfd1' : 'none',
        '&:hover': {
            borderColor: error ? '#ff0000' : '#b8bfd1'
        },
        minHeight: '48px',
        fontSize: '16px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        transition: 'border-color 0.2s, box-shadow 0.2s',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '8px 16px',
        outline: 'none',
        '& input': {
            outline: 'none !important',
            boxShadow: 'none !important',
            border: 'none !important',
        }
    }),
    input: (provided) => ({
        ...provided,
        margin: '0',
        padding: '0',
        fontSize: '16px',
        color: '#4a4a4a',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b2b2b2',
        fontSize: '16px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        fontSize: '16px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        marginTop: '4px',
        border: '1px solid #e7e7e7',
        overflow: 'hidden',
    }),
    menuList: (provided) => ({
            ...provided,
            maxHeight: '300px',
            padding: '0',
            '::-webkit-scrollbar': {
            width: '8px',
        },
        '::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '4px',
        },
        '::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? '#4a4a4a' 
        : state.isFocused 
          ? '#f5f5f5' 
          : 'white',
      color: state.isSelected ? 'white' : '#4a4a4a',
      padding: '12px 16px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'background-color 0.15s',
      '&:active': {
        backgroundColor: state.isSelected ? '#4a4a4a' : '#e7e7e7',
      }
    }),
    loadingMessage: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#b2b2b2',
      padding: '12px',
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#b2b2b2',
      padding: '12px',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? '#4a4a4a' : '#b2b2b2',
      padding: '8px',
      transition: 'color 0.2s',
      '&:hover': {
        color: '#4a4a4a',
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: '#e7e7e7',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: '#b2b2b2',
      padding: '8px',
      '&:hover': {
        color: '#ff0000',
      },
    }),
  };

  return (
    <div className={css.campo}>
      <label className={`${css.label} ${error ? css.labelError : ''}`}>
        {label}
      </label>
      <Select
        value={selectedOption}
        onChange={handleChange}
        options={selectOptions}
        placeholder={placeholder || 'Seleccionar...'}
        isDisabled={disabled}
        isLoading={isLoading}
        isClearable={false}
        isSearchable={true}
        noOptionsMessage={() => 'No se encontraron resultados'}
        loadingMessage={() => 'Cargando...'}
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        filterOption={(option, inputValue) => {
          // Búsqueda case-insensitive y sin acentos
          const normalizeText = (text) => 
            text.normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();
          
          return normalizeText(option.label).includes(normalizeText(inputValue));
        }}
      />
      {/* {error && (
        <div className={css.errorMessage}>
          <small>Por favor seleccioná una opción válida</small>
        </div>
      )} */}
    </div>
  )
}

export default SelectAutocomplete;